/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DecideReturnInputBody,
  DeliveryInputBody,
  DeliveryMethodBody,
  DeliveryMethodsOutputBody,
  EnableShopInputBody,
  ErrorModel,
  GiftCardBody,
  GiftCardsOutputBody,
  IssueGiftCardInputBody,
  PartialRefundInputBody,
  PromoBody,
  PromoInputBody,
  PromosOutputBody,
  ReorderDeliveryInputBody,
  SetStockInputBody,
  ShopOrderBody,
  ShopSettingsBody,
  ShopUpdateHeaders,
  StockBody,
  ToggleGiftCardInputBody,
  UpdateShopInputBody,
  VariantsBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type shopOrderResponse200 = {
  data: ShopOrderBody
  status: 200
}

export type shopOrderResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopOrderResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopOrderResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopOrderResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopOrderResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopOrderResponseSuccess = (shopOrderResponse200) & {
  headers: Headers;
};
export type shopOrderResponseError = (shopOrderResponse401 | shopOrderResponse403 | shopOrderResponse404 | shopOrderResponse422 | shopOrderResponse500) & {
  headers: Headers;
};

export type shopOrderResponse = (shopOrderResponseSuccess | shopOrderResponseError)

export const getShopOrderUrl = (recordId: string,) => {




  return `/records/${recordId}/shop-order`
}

/**
 * Номер, сумма, оплата. Запись не из заказов магазина — 404.
 * @summary Заказ магазина
 */
export const shopOrder = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<shopOrderResponse> => {

  return facetaFetch<shopOrderResponse>(getShopOrderUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopOrderQueryKey = (recordId: string,) => {
    return [
    `/records/${recordId}/shop-order`
    ] as const;
    }


export const getShopOrderQueryOptions = <TData = Awaited<ReturnType<typeof shopOrder>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopOrder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopOrderQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopOrder>>> = ({ signal }) => shopOrder(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopOrderQueryResult = NonNullable<Awaited<ReturnType<typeof shopOrder>>>
export type ShopOrderQueryError = ErrorModel


export function useShopOrder<TData = Awaited<ReturnType<typeof shopOrder>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopOrder>>,
          TError,
          Awaited<ReturnType<typeof shopOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopOrder<TData = Awaited<ReturnType<typeof shopOrder>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopOrder>>,
          TError,
          Awaited<ReturnType<typeof shopOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopOrder<TData = Awaited<ReturnType<typeof shopOrder>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopOrder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Заказ магазина
 */

export function useShopOrder<TData = Awaited<ReturnType<typeof shopOrder>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopOrder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopOrderQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopRefundResponse200 = {
  data: ShopOrderBody
  status: 200
}

export type shopRefundResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopRefundResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopRefundResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopRefundResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopRefundResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopRefundResponseSuccess = (shopRefundResponse200) & {
  headers: Headers;
};
export type shopRefundResponseError = (shopRefundResponse401 | shopRefundResponse403 | shopRefundResponse404 | shopRefundResponse422 | shopRefundResponse500) & {
  headers: Headers;
};

export type shopRefundResponse = (shopRefundResponseSuccess | shopRefundResponseError)

export const getShopRefundUrl = (recordId: string,) => {




  return `/records/${recordId}/shop-order/refund`
}

/**
 * Целиком, через того же провайдера. Заказ — в «отменён», товар — на склад.
 * @summary Вернуть деньги
 */
export const shopRefund = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<shopRefundResponse> => {

  return facetaFetch<shopRefundResponse>(getShopRefundUrl(recordId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getShopRefundQueryKey = (recordId: string,) => {
    return [
    'POST', `/records/${recordId}/shop-order/refund`
    ] as const;
    }


export const getShopRefundQueryOptions = <TData = Awaited<ReturnType<typeof shopRefund>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopRefund>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopRefundQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopRefund>>> = ({ signal }) => shopRefund(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopRefund>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopRefundQueryResult = NonNullable<Awaited<ReturnType<typeof shopRefund>>>
export type ShopRefundQueryError = ErrorModel


export function useShopRefund<TData = Awaited<ReturnType<typeof shopRefund>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopRefund>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopRefund>>,
          TError,
          Awaited<ReturnType<typeof shopRefund>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopRefund<TData = Awaited<ReturnType<typeof shopRefund>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopRefund>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopRefund>>,
          TError,
          Awaited<ReturnType<typeof shopRefund>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopRefund<TData = Awaited<ReturnType<typeof shopRefund>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopRefund>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть деньги
 */

export function useShopRefund<TData = Awaited<ReturnType<typeof shopRefund>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopRefund>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopRefundQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopPartialRefundResponse200 = {
  data: ShopOrderBody
  status: 200
}

export type shopPartialRefundResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopPartialRefundResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopPartialRefundResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopPartialRefundResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopPartialRefundResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopPartialRefundResponseSuccess = (shopPartialRefundResponse200) & {
  headers: Headers;
};
export type shopPartialRefundResponseError = (shopPartialRefundResponse401 | shopPartialRefundResponse403 | shopPartialRefundResponse404 | shopPartialRefundResponse422 | shopPartialRefundResponse500) & {
  headers: Headers;
};

export type shopPartialRefundResponse = (shopPartialRefundResponseSuccess | shopPartialRefundResponseError)

export const getShopPartialRefundUrl = (recordId: string,) => {




  return `/records/${recordId}/shop-order/returns`
}

/**
 * Позиции и сумму — через того же провайдера; без онлайн-оплаты — только запись. С restock товар — на склад. Заказ остаётся в своём статусе.
 * @summary Вернуть часть
 */
export const shopPartialRefund = async (recordId: string,
    partialRefundInputBody: NonReadonly<PartialRefundInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopPartialRefundResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopPartialRefundResponse>(getShopPartialRefundUrl(recordId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(partialRefundInputBody)
  }
);}





export const getShopPartialRefundQueryKey = (recordId: string,
    partialRefundInputBody?: NonReadonly<PartialRefundInputBody>,) => {
    return [
    'POST', `/records/${recordId}/shop-order/returns`, partialRefundInputBody
    ] as const;
    }


export const getShopPartialRefundQueryOptions = <TData = Awaited<ReturnType<typeof shopPartialRefund>>, TError = ErrorModel>(recordId: string,
    partialRefundInputBody: NonReadonly<PartialRefundInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPartialRefund>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopPartialRefundQueryKey(recordId,partialRefundInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopPartialRefund>>> = ({ signal }) => shopPartialRefund(recordId,partialRefundInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopPartialRefund>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopPartialRefundQueryResult = NonNullable<Awaited<ReturnType<typeof shopPartialRefund>>>
export type ShopPartialRefundQueryError = ErrorModel


export function useShopPartialRefund<TData = Awaited<ReturnType<typeof shopPartialRefund>>, TError = ErrorModel>(
 recordId: string,
    partialRefundInputBody: NonReadonly<PartialRefundInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPartialRefund>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPartialRefund>>,
          TError,
          Awaited<ReturnType<typeof shopPartialRefund>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPartialRefund<TData = Awaited<ReturnType<typeof shopPartialRefund>>, TError = ErrorModel>(
 recordId: string,
    partialRefundInputBody: NonReadonly<PartialRefundInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPartialRefund>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPartialRefund>>,
          TError,
          Awaited<ReturnType<typeof shopPartialRefund>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPartialRefund<TData = Awaited<ReturnType<typeof shopPartialRefund>>, TError = ErrorModel>(
 recordId: string,
    partialRefundInputBody: NonReadonly<PartialRefundInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPartialRefund>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть часть
 */

export function useShopPartialRefund<TData = Awaited<ReturnType<typeof shopPartialRefund>>, TError = ErrorModel>(
 recordId: string,
    partialRefundInputBody: NonReadonly<PartialRefundInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPartialRefund>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopPartialRefundQueryOptions(recordId,partialRefundInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDecideReturnResponse200 = {
  data: ShopOrderBody
  status: 200
}

export type shopDecideReturnResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDecideReturnResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDecideReturnResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDecideReturnResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDecideReturnResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDecideReturnResponseSuccess = (shopDecideReturnResponse200) & {
  headers: Headers;
};
export type shopDecideReturnResponseError = (shopDecideReturnResponse401 | shopDecideReturnResponse403 | shopDecideReturnResponse404 | shopDecideReturnResponse422 | shopDecideReturnResponse500) & {
  headers: Headers;
};

export type shopDecideReturnResponse = (shopDecideReturnResponseSuccess | shopDecideReturnResponseError)

export const getShopDecideReturnUrl = (recordId: string,
    returnId: string,) => {




  return `/records/${recordId}/shop-order/returns/${returnId}`
}

/**
 * Вернуть деньги (сумма — не больше оплаченного за вычетом уже возвращённого) или отказать.
 * @summary Решение по возврату
 */
export const shopDecideReturn = async (recordId: string,
    returnId: string,
    decideReturnInputBody: NonReadonly<DecideReturnInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopDecideReturnResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopDecideReturnResponse>(getShopDecideReturnUrl(recordId,returnId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(decideReturnInputBody)
  }
);}





export const getShopDecideReturnQueryKey = (recordId: string,
    returnId: string,
    decideReturnInputBody?: NonReadonly<DecideReturnInputBody>,) => {
    return [
    'POST', `/records/${recordId}/shop-order/returns/${returnId}`, decideReturnInputBody
    ] as const;
    }


export const getShopDecideReturnQueryOptions = <TData = Awaited<ReturnType<typeof shopDecideReturn>>, TError = ErrorModel>(recordId: string,
    returnId: string,
    decideReturnInputBody: NonReadonly<DecideReturnInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDecideReturn>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDecideReturnQueryKey(recordId,returnId,decideReturnInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDecideReturn>>> = ({ signal }) => shopDecideReturn(recordId,returnId,decideReturnInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined && returnId !== null && returnId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDecideReturn>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDecideReturnQueryResult = NonNullable<Awaited<ReturnType<typeof shopDecideReturn>>>
export type ShopDecideReturnQueryError = ErrorModel


export function useShopDecideReturn<TData = Awaited<ReturnType<typeof shopDecideReturn>>, TError = ErrorModel>(
 recordId: string,
    returnId: string,
    decideReturnInputBody: NonReadonly<DecideReturnInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDecideReturn>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDecideReturn>>,
          TError,
          Awaited<ReturnType<typeof shopDecideReturn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDecideReturn<TData = Awaited<ReturnType<typeof shopDecideReturn>>, TError = ErrorModel>(
 recordId: string,
    returnId: string,
    decideReturnInputBody: NonReadonly<DecideReturnInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDecideReturn>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDecideReturn>>,
          TError,
          Awaited<ReturnType<typeof shopDecideReturn>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDecideReturn<TData = Awaited<ReturnType<typeof shopDecideReturn>>, TError = ErrorModel>(
 recordId: string,
    returnId: string,
    decideReturnInputBody: NonReadonly<DecideReturnInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDecideReturn>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Решение по возврату
 */

export function useShopDecideReturn<TData = Awaited<ReturnType<typeof shopDecideReturn>>, TError = ErrorModel>(
 recordId: string,
    returnId: string,
    decideReturnInputBody: NonReadonly<DecideReturnInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDecideReturn>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDecideReturnQueryOptions(recordId,returnId,decideReturnInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopStockResponse200 = {
  data: StockBody
  status: 200
}

export type shopStockResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopStockResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopStockResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopStockResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopStockResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopStockResponseSuccess = (shopStockResponse200) & {
  headers: Headers;
};
export type shopStockResponseError = (shopStockResponse401 | shopStockResponse403 | shopStockResponse404 | shopStockResponse422 | shopStockResponse500) & {
  headers: Headers;
};

export type shopStockResponse = (shopStockResponseSuccess | shopStockResponseError)

export const getShopStockUrl = (recordId: string,) => {




  return `/records/${recordId}/stock`
}

/**
 * Запись не из товаров магазина — 404.
 * @summary Остаток товара
 */
export const shopStock = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<shopStockResponse> => {

  return facetaFetch<shopStockResponse>(getShopStockUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopStockQueryKey = (recordId: string,) => {
    return [
    `/records/${recordId}/stock`
    ] as const;
    }


export const getShopStockQueryOptions = <TData = Awaited<ReturnType<typeof shopStock>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopStock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopStockQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopStock>>> = ({ signal }) => shopStock(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopStock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopStockQueryResult = NonNullable<Awaited<ReturnType<typeof shopStock>>>
export type ShopStockQueryError = ErrorModel


export function useShopStock<TData = Awaited<ReturnType<typeof shopStock>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopStock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopStock>>,
          TError,
          Awaited<ReturnType<typeof shopStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopStock<TData = Awaited<ReturnType<typeof shopStock>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopStock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopStock>>,
          TError,
          Awaited<ReturnType<typeof shopStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopStock<TData = Awaited<ReturnType<typeof shopStock>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopStock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Остаток товара
 */

export function useShopStock<TData = Awaited<ReturnType<typeof shopStock>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopStock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopStockQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopSetStockResponse200 = {
  data: StockBody
  status: 200
}

export type shopSetStockResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopSetStockResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopSetStockResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopSetStockResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopSetStockResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopSetStockResponseSuccess = (shopSetStockResponse200) & {
  headers: Headers;
};
export type shopSetStockResponseError = (shopSetStockResponse401 | shopSetStockResponse403 | shopSetStockResponse404 | shopSetStockResponse422 | shopSetStockResponse500) & {
  headers: Headers;
};

export type shopSetStockResponse = (shopSetStockResponseSuccess | shopSetStockResponseError)

export const getShopSetStockUrl = (recordId: string,) => {




  return `/records/${recordId}/stock`
}

/**
 * Сразу, без публикации. Отложенное под неоплаченные заказы уже вычтено и вернётся при их отмене.
 * @summary Задать остаток
 */
export const shopSetStock = async (recordId: string,
    setStockInputBody: NonReadonly<SetStockInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopSetStockResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopSetStockResponse>(getShopSetStockUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setStockInputBody)
  }
);}





export const getShopSetStockQueryKey = (recordId: string,
    setStockInputBody?: NonReadonly<SetStockInputBody>,) => {
    return [
    'PUT', `/records/${recordId}/stock`, setStockInputBody
    ] as const;
    }


export const getShopSetStockQueryOptions = <TData = Awaited<ReturnType<typeof shopSetStock>>, TError = ErrorModel>(recordId: string,
    setStockInputBody: NonReadonly<SetStockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetStock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopSetStockQueryKey(recordId,setStockInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopSetStock>>> = ({ signal }) => shopSetStock(recordId,setStockInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopSetStock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopSetStockQueryResult = NonNullable<Awaited<ReturnType<typeof shopSetStock>>>
export type ShopSetStockQueryError = ErrorModel


export function useShopSetStock<TData = Awaited<ReturnType<typeof shopSetStock>>, TError = ErrorModel>(
 recordId: string,
    setStockInputBody: NonReadonly<SetStockInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetStock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopSetStock>>,
          TError,
          Awaited<ReturnType<typeof shopSetStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopSetStock<TData = Awaited<ReturnType<typeof shopSetStock>>, TError = ErrorModel>(
 recordId: string,
    setStockInputBody: NonReadonly<SetStockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetStock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopSetStock>>,
          TError,
          Awaited<ReturnType<typeof shopSetStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopSetStock<TData = Awaited<ReturnType<typeof shopSetStock>>, TError = ErrorModel>(
 recordId: string,
    setStockInputBody: NonReadonly<SetStockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetStock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Задать остаток
 */

export function useShopSetStock<TData = Awaited<ReturnType<typeof shopSetStock>>, TError = ErrorModel>(
 recordId: string,
    setStockInputBody: NonReadonly<SetStockInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetStock>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopSetStockQueryOptions(recordId,setStockInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopVariantsResponse200 = {
  data: VariantsBody
  status: 200
}

export type shopVariantsResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopVariantsResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopVariantsResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopVariantsResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopVariantsResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopVariantsResponseSuccess = (shopVariantsResponse200) & {
  headers: Headers;
};
export type shopVariantsResponseError = (shopVariantsResponse401 | shopVariantsResponse403 | shopVariantsResponse404 | shopVariantsResponse422 | shopVariantsResponse500) & {
  headers: Headers;
};

export type shopVariantsResponse = (shopVariantsResponseSuccess | shopVariantsResponseError)

export const getShopVariantsUrl = (recordId: string,) => {




  return `/records/${recordId}/variants`
}

/**
 * Оси (размер, цвет) и варианты со своим артикулом, ценой и остатком. Не товар магазина — 404.
 * @summary Варианты товара
 */
export const shopVariants = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<shopVariantsResponse> => {

  return facetaFetch<shopVariantsResponse>(getShopVariantsUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopVariantsQueryKey = (recordId: string,) => {
    return [
    `/records/${recordId}/variants`
    ] as const;
    }


export const getShopVariantsQueryOptions = <TData = Awaited<ReturnType<typeof shopVariants>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopVariants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopVariantsQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopVariants>>> = ({ signal }) => shopVariants(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopVariants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopVariantsQueryResult = NonNullable<Awaited<ReturnType<typeof shopVariants>>>
export type ShopVariantsQueryError = ErrorModel


export function useShopVariants<TData = Awaited<ReturnType<typeof shopVariants>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopVariants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopVariants>>,
          TError,
          Awaited<ReturnType<typeof shopVariants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopVariants<TData = Awaited<ReturnType<typeof shopVariants>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopVariants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopVariants>>,
          TError,
          Awaited<ReturnType<typeof shopVariants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopVariants<TData = Awaited<ReturnType<typeof shopVariants>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopVariants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Варианты товара
 */

export function useShopVariants<TData = Awaited<ReturnType<typeof shopVariants>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopVariants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopVariantsQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopSetVariantsResponse200 = {
  data: VariantsBody
  status: 200
}

export type shopSetVariantsResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopSetVariantsResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopSetVariantsResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopSetVariantsResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopSetVariantsResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopSetVariantsResponseSuccess = (shopSetVariantsResponse200) & {
  headers: Headers;
};
export type shopSetVariantsResponseError = (shopSetVariantsResponse401 | shopSetVariantsResponse403 | shopSetVariantsResponse404 | shopSetVariantsResponse422 | shopSetVariantsResponse500) & {
  headers: Headers;
};

export type shopSetVariantsResponse = (shopSetVariantsResponseSuccess | shopSetVariantsResponseError)

export const getShopSetVariantsUrl = (recordId: string,) => {




  return `/records/${recordId}/variants`
}

/**
 * Целиком: с id — меняются, без id — заводятся, остальные убираются. Сразу, без публикации. У каждого варианта — ровно по значению каждой оси, сочетания не повторяются.
 * @summary Задать варианты товара
 */
export const shopSetVariants = async (recordId: string,
    variantsBody: NonReadonly<VariantsBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopSetVariantsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopSetVariantsResponse>(getShopSetVariantsUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(variantsBody)
  }
);}





export const getShopSetVariantsQueryKey = (recordId: string,
    variantsBody?: NonReadonly<VariantsBody>,) => {
    return [
    'PUT', `/records/${recordId}/variants`, variantsBody
    ] as const;
    }


export const getShopSetVariantsQueryOptions = <TData = Awaited<ReturnType<typeof shopSetVariants>>, TError = ErrorModel>(recordId: string,
    variantsBody: NonReadonly<VariantsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetVariants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopSetVariantsQueryKey(recordId,variantsBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopSetVariants>>> = ({ signal }) => shopSetVariants(recordId,variantsBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopSetVariants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopSetVariantsQueryResult = NonNullable<Awaited<ReturnType<typeof shopSetVariants>>>
export type ShopSetVariantsQueryError = ErrorModel


export function useShopSetVariants<TData = Awaited<ReturnType<typeof shopSetVariants>>, TError = ErrorModel>(
 recordId: string,
    variantsBody: NonReadonly<VariantsBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetVariants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopSetVariants>>,
          TError,
          Awaited<ReturnType<typeof shopSetVariants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopSetVariants<TData = Awaited<ReturnType<typeof shopSetVariants>>, TError = ErrorModel>(
 recordId: string,
    variantsBody: NonReadonly<VariantsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetVariants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopSetVariants>>,
          TError,
          Awaited<ReturnType<typeof shopSetVariants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopSetVariants<TData = Awaited<ReturnType<typeof shopSetVariants>>, TError = ErrorModel>(
 recordId: string,
    variantsBody: NonReadonly<VariantsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetVariants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Задать варианты товара
 */

export function useShopSetVariants<TData = Awaited<ReturnType<typeof shopSetVariants>>, TError = ErrorModel>(
 recordId: string,
    variantsBody: NonReadonly<VariantsBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopSetVariants>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopSetVariantsQueryOptions(recordId,variantsBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDeliveryDeleteResponse204 = {
  data: void
  status: 204
}

export type shopDeliveryDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDeliveryDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDeliveryDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDeliveryDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDeliveryDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDeliveryDeleteResponseSuccess = (shopDeliveryDeleteResponse204) & {
  headers: Headers;
};
export type shopDeliveryDeleteResponseError = (shopDeliveryDeleteResponse401 | shopDeliveryDeleteResponse403 | shopDeliveryDeleteResponse404 | shopDeliveryDeleteResponse422 | shopDeliveryDeleteResponse500) & {
  headers: Headers;
};

export type shopDeliveryDeleteResponse = (shopDeliveryDeleteResponseSuccess | shopDeliveryDeleteResponseError)

export const getShopDeliveryDeleteUrl = (methodId: string,) => {




  return `/shop/delivery/${methodId}`
}

/**
 * Заказы с ним остаются — способ в них записан.
 * @summary Удалить способ доставки
 */
export const shopDeliveryDelete = async (methodId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<shopDeliveryDeleteResponse> => {

  return facetaFetch<shopDeliveryDeleteResponse>(getShopDeliveryDeleteUrl(methodId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getShopDeliveryDeleteQueryKey = (methodId: string,) => {
    return [
    'DELETE', `/shop/delivery/${methodId}`
    ] as const;
    }


export const getShopDeliveryDeleteQueryOptions = <TData = Awaited<ReturnType<typeof shopDeliveryDelete>>, TError = ErrorModel>(methodId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDeliveryDeleteQueryKey(methodId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDeliveryDelete>>> = ({ signal }) => shopDeliveryDelete(methodId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: methodId !== null && methodId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDeliveryDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof shopDeliveryDelete>>>
export type ShopDeliveryDeleteQueryError = ErrorModel


export function useShopDeliveryDelete<TData = Awaited<ReturnType<typeof shopDeliveryDelete>>, TError = ErrorModel>(
 methodId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryDelete>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryDelete<TData = Awaited<ReturnType<typeof shopDeliveryDelete>>, TError = ErrorModel>(
 methodId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryDelete>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryDelete<TData = Awaited<ReturnType<typeof shopDeliveryDelete>>, TError = ErrorModel>(
 methodId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить способ доставки
 */

export function useShopDeliveryDelete<TData = Awaited<ReturnType<typeof shopDeliveryDelete>>, TError = ErrorModel>(
 methodId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDeliveryDeleteQueryOptions(methodId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDeliveryUpdateResponse200 = {
  data: DeliveryMethodBody
  status: 200
}

export type shopDeliveryUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDeliveryUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDeliveryUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDeliveryUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDeliveryUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDeliveryUpdateResponseSuccess = (shopDeliveryUpdateResponse200) & {
  headers: Headers;
};
export type shopDeliveryUpdateResponseError = (shopDeliveryUpdateResponse401 | shopDeliveryUpdateResponse403 | shopDeliveryUpdateResponse404 | shopDeliveryUpdateResponse422 | shopDeliveryUpdateResponse500) & {
  headers: Headers;
};

export type shopDeliveryUpdateResponse = (shopDeliveryUpdateResponseSuccess | shopDeliveryUpdateResponseError)

export const getShopDeliveryUpdateUrl = (methodId: string,) => {




  return `/shop/delivery/${methodId}`
}

/**
 * Целиком.
 * @summary Изменить способ доставки
 */
export const shopDeliveryUpdate = async (methodId: string,
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopDeliveryUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopDeliveryUpdateResponse>(getShopDeliveryUpdateUrl(methodId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deliveryInputBody)
  }
);}





export const getShopDeliveryUpdateQueryKey = (methodId: string,
    deliveryInputBody?: NonReadonly<DeliveryInputBody>,) => {
    return [
    'PUT', `/shop/delivery/${methodId}`, deliveryInputBody
    ] as const;
    }


export const getShopDeliveryUpdateQueryOptions = <TData = Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError = ErrorModel>(methodId: string,
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDeliveryUpdateQueryKey(methodId,deliveryInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDeliveryUpdate>>> = ({ signal }) => shopDeliveryUpdate(methodId,deliveryInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: methodId !== null && methodId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDeliveryUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof shopDeliveryUpdate>>>
export type ShopDeliveryUpdateQueryError = ErrorModel


export function useShopDeliveryUpdate<TData = Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError = ErrorModel>(
 methodId: string,
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryUpdate>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryUpdate<TData = Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError = ErrorModel>(
 methodId: string,
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryUpdate>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryUpdate<TData = Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError = ErrorModel>(
 methodId: string,
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить способ доставки
 */

export function useShopDeliveryUpdate<TData = Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError = ErrorModel>(
 methodId: string,
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDeliveryUpdateQueryOptions(methodId,deliveryInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopGiftCardToggleResponse200 = {
  data: GiftCardBody
  status: 200
}

export type shopGiftCardToggleResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopGiftCardToggleResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopGiftCardToggleResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopGiftCardToggleResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopGiftCardToggleResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopGiftCardToggleResponseSuccess = (shopGiftCardToggleResponse200) & {
  headers: Headers;
};
export type shopGiftCardToggleResponseError = (shopGiftCardToggleResponse401 | shopGiftCardToggleResponse403 | shopGiftCardToggleResponse404 | shopGiftCardToggleResponse422 | shopGiftCardToggleResponse500) & {
  headers: Headers;
};

export type shopGiftCardToggleResponse = (shopGiftCardToggleResponseSuccess | shopGiftCardToggleResponseError)

export const getShopGiftCardToggleUrl = (cardId: string,) => {




  return `/shop/gift-cards/${cardId}`
}

/**
 * Отключённым не заплатить; остаток сохраняется.
 * @summary Отключить или включить сертификат
 */
export const shopGiftCardToggle = async (cardId: string,
    toggleGiftCardInputBody: NonReadonly<ToggleGiftCardInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopGiftCardToggleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopGiftCardToggleResponse>(getShopGiftCardToggleUrl(cardId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(toggleGiftCardInputBody)
  }
);}





export const getShopGiftCardToggleQueryKey = (cardId: string,
    toggleGiftCardInputBody?: NonReadonly<ToggleGiftCardInputBody>,) => {
    return [
    'PUT', `/shop/gift-cards/${cardId}`, toggleGiftCardInputBody
    ] as const;
    }


export const getShopGiftCardToggleQueryOptions = <TData = Awaited<ReturnType<typeof shopGiftCardToggle>>, TError = ErrorModel>(cardId: string,
    toggleGiftCardInputBody: NonReadonly<ToggleGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardToggle>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopGiftCardToggleQueryKey(cardId,toggleGiftCardInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopGiftCardToggle>>> = ({ signal }) => shopGiftCardToggle(cardId,toggleGiftCardInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: cardId !== null && cardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardToggle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopGiftCardToggleQueryResult = NonNullable<Awaited<ReturnType<typeof shopGiftCardToggle>>>
export type ShopGiftCardToggleQueryError = ErrorModel


export function useShopGiftCardToggle<TData = Awaited<ReturnType<typeof shopGiftCardToggle>>, TError = ErrorModel>(
 cardId: string,
    toggleGiftCardInputBody: NonReadonly<ToggleGiftCardInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardToggle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGiftCardToggle>>,
          TError,
          Awaited<ReturnType<typeof shopGiftCardToggle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGiftCardToggle<TData = Awaited<ReturnType<typeof shopGiftCardToggle>>, TError = ErrorModel>(
 cardId: string,
    toggleGiftCardInputBody: NonReadonly<ToggleGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardToggle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGiftCardToggle>>,
          TError,
          Awaited<ReturnType<typeof shopGiftCardToggle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGiftCardToggle<TData = Awaited<ReturnType<typeof shopGiftCardToggle>>, TError = ErrorModel>(
 cardId: string,
    toggleGiftCardInputBody: NonReadonly<ToggleGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardToggle>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отключить или включить сертификат
 */

export function useShopGiftCardToggle<TData = Awaited<ReturnType<typeof shopGiftCardToggle>>, TError = ErrorModel>(
 cardId: string,
    toggleGiftCardInputBody: NonReadonly<ToggleGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardToggle>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopGiftCardToggleQueryOptions(cardId,toggleGiftCardInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopPromoDeleteResponse204 = {
  data: void
  status: 204
}

export type shopPromoDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopPromoDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopPromoDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopPromoDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopPromoDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopPromoDeleteResponseSuccess = (shopPromoDeleteResponse204) & {
  headers: Headers;
};
export type shopPromoDeleteResponseError = (shopPromoDeleteResponse401 | shopPromoDeleteResponse403 | shopPromoDeleteResponse404 | shopPromoDeleteResponse422 | shopPromoDeleteResponse500) & {
  headers: Headers;
};

export type shopPromoDeleteResponse = (shopPromoDeleteResponseSuccess | shopPromoDeleteResponseError)

export const getShopPromoDeleteUrl = (promoId: string,) => {




  return `/shop/promos/${promoId}`
}

/**
 * Заказы с ним остаются — в них код записан.
 * @summary Удалить промокод
 */
export const shopPromoDelete = async (promoId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<shopPromoDeleteResponse> => {

  return facetaFetch<shopPromoDeleteResponse>(getShopPromoDeleteUrl(promoId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getShopPromoDeleteQueryKey = (promoId: string,) => {
    return [
    'DELETE', `/shop/promos/${promoId}`
    ] as const;
    }


export const getShopPromoDeleteQueryOptions = <TData = Awaited<ReturnType<typeof shopPromoDelete>>, TError = ErrorModel>(promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopPromoDeleteQueryKey(promoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopPromoDelete>>> = ({ signal }) => shopPromoDelete(promoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: promoId !== null && promoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopPromoDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopPromoDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof shopPromoDelete>>>
export type ShopPromoDeleteQueryError = ErrorModel


export function useShopPromoDelete<TData = Awaited<ReturnType<typeof shopPromoDelete>>, TError = ErrorModel>(
 promoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromoDelete>>,
          TError,
          Awaited<ReturnType<typeof shopPromoDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromoDelete<TData = Awaited<ReturnType<typeof shopPromoDelete>>, TError = ErrorModel>(
 promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromoDelete>>,
          TError,
          Awaited<ReturnType<typeof shopPromoDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromoDelete<TData = Awaited<ReturnType<typeof shopPromoDelete>>, TError = ErrorModel>(
 promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить промокод
 */

export function useShopPromoDelete<TData = Awaited<ReturnType<typeof shopPromoDelete>>, TError = ErrorModel>(
 promoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopPromoDeleteQueryOptions(promoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopPromoUpdateResponse200 = {
  data: PromoBody
  status: 200
}

export type shopPromoUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopPromoUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopPromoUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopPromoUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type shopPromoUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopPromoUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopPromoUpdateResponseSuccess = (shopPromoUpdateResponse200) & {
  headers: Headers;
};
export type shopPromoUpdateResponseError = (shopPromoUpdateResponse401 | shopPromoUpdateResponse403 | shopPromoUpdateResponse404 | shopPromoUpdateResponse409 | shopPromoUpdateResponse422 | shopPromoUpdateResponse500) & {
  headers: Headers;
};

export type shopPromoUpdateResponse = (shopPromoUpdateResponseSuccess | shopPromoUpdateResponseError)

export const getShopPromoUpdateUrl = (promoId: string,) => {




  return `/shop/promos/${promoId}`
}

/**
 * Целиком. Счётчик использований не сбрасывается.
 * @summary Изменить промокод
 */
export const shopPromoUpdate = async (promoId: string,
    promoInputBody: NonReadonly<PromoInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopPromoUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopPromoUpdateResponse>(getShopPromoUpdateUrl(promoId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoInputBody)
  }
);}





export const getShopPromoUpdateQueryKey = (promoId: string,
    promoInputBody?: NonReadonly<PromoInputBody>,) => {
    return [
    'PUT', `/shop/promos/${promoId}`, promoInputBody
    ] as const;
    }


export const getShopPromoUpdateQueryOptions = <TData = Awaited<ReturnType<typeof shopPromoUpdate>>, TError = ErrorModel>(promoId: string,
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopPromoUpdateQueryKey(promoId,promoInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopPromoUpdate>>> = ({ signal }) => shopPromoUpdate(promoId,promoInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: promoId !== null && promoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopPromoUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopPromoUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof shopPromoUpdate>>>
export type ShopPromoUpdateQueryError = ErrorModel


export function useShopPromoUpdate<TData = Awaited<ReturnType<typeof shopPromoUpdate>>, TError = ErrorModel>(
 promoId: string,
    promoInputBody: NonReadonly<PromoInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromoUpdate>>,
          TError,
          Awaited<ReturnType<typeof shopPromoUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromoUpdate<TData = Awaited<ReturnType<typeof shopPromoUpdate>>, TError = ErrorModel>(
 promoId: string,
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromoUpdate>>,
          TError,
          Awaited<ReturnType<typeof shopPromoUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromoUpdate<TData = Awaited<ReturnType<typeof shopPromoUpdate>>, TError = ErrorModel>(
 promoId: string,
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить промокод
 */

export function useShopPromoUpdate<TData = Awaited<ReturnType<typeof shopPromoUpdate>>, TError = ErrorModel>(
 promoId: string,
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopPromoUpdateQueryOptions(promoId,promoInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDisableResponse204 = {
  data: void
  status: 204
}

export type shopDisableResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDisableResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDisableResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDisableResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDisableResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDisableResponseSuccess = (shopDisableResponse204) & {
  headers: Headers;
};
export type shopDisableResponseError = (shopDisableResponse401 | shopDisableResponse403 | shopDisableResponse404 | shopDisableResponse422 | shopDisableResponse500) & {
  headers: Headers;
};

export type shopDisableResponse = (shopDisableResponseSuccess | shopDisableResponseError)

export const getShopDisableUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop`
}

/**
 * Товары, заказы, остатки и платежи остаются; оформление с сайта перестаёт работать.
 * @summary Выключить магазин
 */
export const shopDisable = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<shopDisableResponse> => {

  return facetaFetch<shopDisableResponse>(getShopDisableUrl(id,kind),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getShopDisableQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    'DELETE', `/sites/${id}/environments/${kind}/shop`
    ] as const;
    }


export const getShopDisableQueryOptions = <TData = Awaited<ReturnType<typeof shopDisable>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDisable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDisableQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDisable>>> = ({ signal }) => shopDisable(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDisable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDisableQueryResult = NonNullable<Awaited<ReturnType<typeof shopDisable>>>
export type ShopDisableQueryError = ErrorModel


export function useShopDisable<TData = Awaited<ReturnType<typeof shopDisable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDisable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDisable>>,
          TError,
          Awaited<ReturnType<typeof shopDisable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDisable<TData = Awaited<ReturnType<typeof shopDisable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDisable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDisable>>,
          TError,
          Awaited<ReturnType<typeof shopDisable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDisable<TData = Awaited<ReturnType<typeof shopDisable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDisable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Выключить магазин
 */

export function useShopDisable<TData = Awaited<ReturnType<typeof shopDisable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDisable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDisableQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopGetResponse200 = {
  data: ShopSettingsBody
  status: 200
}

export type shopGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopGetResponseSuccess = (shopGetResponse200) & {
  headers: Headers;
};
export type shopGetResponseError = (shopGetResponse401 | shopGetResponse403 | shopGetResponse404 | shopGetResponse422 | shopGetResponse500) & {
  headers: Headers;
};

export type shopGetResponse = (shopGetResponseSuccess | shopGetResponseError)

export const getShopGetUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop`
}

/**
 * @summary Магазин окружения
 */
export const shopGet = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<shopGetResponse> => {

  return facetaFetch<shopGetResponse>(getShopGetUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopGetQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/shop`
    ] as const;
    }


export const getShopGetQueryOptions = <TData = Awaited<ReturnType<typeof shopGet>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopGetQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopGet>>> = ({ signal }) => shopGet(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopGetQueryResult = NonNullable<Awaited<ReturnType<typeof shopGet>>>
export type ShopGetQueryError = ErrorModel


export function useShopGet<TData = Awaited<ReturnType<typeof shopGet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGet>>,
          TError,
          Awaited<ReturnType<typeof shopGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGet<TData = Awaited<ReturnType<typeof shopGet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGet>>,
          TError,
          Awaited<ReturnType<typeof shopGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGet<TData = Awaited<ReturnType<typeof shopGet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Магазин окружения
 */

export function useShopGet<TData = Awaited<ReturnType<typeof shopGet>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopGetQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopEnableResponse201 = {
  data: ShopSettingsBody
  status: 201
}

export type shopEnableResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopEnableResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopEnableResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopEnableResponse409 = {
  data: ErrorModel
  status: 409
}

export type shopEnableResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopEnableResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopEnableResponseSuccess = (shopEnableResponse201) & {
  headers: Headers;
};
export type shopEnableResponseError = (shopEnableResponse401 | shopEnableResponse403 | shopEnableResponse404 | shopEnableResponse409 | shopEnableResponse422 | shopEnableResponse500) & {
  headers: Headers;
};

export type shopEnableResponse = (shopEnableResponseSuccess | shopEnableResponseError)

export const getShopEnableUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop`
}

/**
 * Коллекции товаров и заказов — выбранные или из шаблона «Каталог и заказы». Заказы подгоняются под пак: поля оформления, статусы «оплачен» и «отменён», создавать с сайта — только оформлением. На Development оплата — тестовая, на Production — ЮKassa.
 * @summary Включить магазин
 */
export const shopEnable = async (id: string,
    kind: 'production' | 'development',
    enableShopInputBody?: NonReadonly<EnableShopInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopEnableResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopEnableResponse>(getShopEnableUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(enableShopInputBody)
  }
);}





export const getShopEnableQueryKey = (id: string,
    kind: 'production' | 'development',
    enableShopInputBody?: NonReadonly<EnableShopInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/shop`, enableShopInputBody
    ] as const;
    }


export const getShopEnableQueryOptions = <TData = Awaited<ReturnType<typeof shopEnable>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    enableShopInputBody?: NonReadonly<EnableShopInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopEnable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopEnableQueryKey(id,kind,enableShopInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopEnable>>> = ({ signal }) => shopEnable(id,kind,enableShopInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopEnable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopEnableQueryResult = NonNullable<Awaited<ReturnType<typeof shopEnable>>>
export type ShopEnableQueryError = ErrorModel


export function useShopEnable<TData = Awaited<ReturnType<typeof shopEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    enableShopInputBody: undefined |  NonReadonly<EnableShopInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopEnable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopEnable>>,
          TError,
          Awaited<ReturnType<typeof shopEnable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopEnable<TData = Awaited<ReturnType<typeof shopEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    enableShopInputBody?: NonReadonly<EnableShopInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopEnable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopEnable>>,
          TError,
          Awaited<ReturnType<typeof shopEnable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopEnable<TData = Awaited<ReturnType<typeof shopEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    enableShopInputBody?: NonReadonly<EnableShopInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopEnable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Включить магазин
 */

export function useShopEnable<TData = Awaited<ReturnType<typeof shopEnable>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    enableShopInputBody?: NonReadonly<EnableShopInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopEnable>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopEnableQueryOptions(id,kind,enableShopInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopUpdateResponse200 = {
  data: ShopSettingsBody
  status: 200
}

export type shopUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopUpdateResponse412 = {
  data: ErrorModel
  status: 412
}

export type shopUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopUpdateResponseSuccess = (shopUpdateResponse200) & {
  headers: Headers;
};
export type shopUpdateResponseError = (shopUpdateResponse401 | shopUpdateResponse403 | shopUpdateResponse404 | shopUpdateResponse412 | shopUpdateResponse422 | shopUpdateResponse500) & {
  headers: Headers;
};

export type shopUpdateResponse = (shopUpdateResponseSuccess | shopUpdateResponseError)

export const getShopUpdateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop`
}

/**
 * Целиком. Пустой секретный ключ — прежний. Тестовая оплата — только на Development.
 * @summary Настройки магазина
 */
export const shopUpdate = async (id: string,
    kind: 'production' | 'development',
    updateShopInputBody: NonReadonly<UpdateShopInputBody>,
    headers: ShopUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<shopUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopUpdateResponse>(getShopUpdateUrl(id,kind),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateShopInputBody)
  }
);}





export const getShopUpdateQueryKey = (id: string,
    kind: 'production' | 'development',
    updateShopInputBody?: NonReadonly<UpdateShopInputBody>,) => {
    return [
    'PUT', `/sites/${id}/environments/${kind}/shop`, updateShopInputBody
    ] as const;
    }


export const getShopUpdateQueryOptions = <TData = Awaited<ReturnType<typeof shopUpdate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    updateShopInputBody: NonReadonly<UpdateShopInputBody>,
    headers: ShopUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopUpdateQueryKey(id,kind,updateShopInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopUpdate>>> = ({ signal }) => shopUpdate(id,kind,updateShopInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof shopUpdate>>>
export type ShopUpdateQueryError = ErrorModel


export function useShopUpdate<TData = Awaited<ReturnType<typeof shopUpdate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    updateShopInputBody: NonReadonly<UpdateShopInputBody>,
    headers: ShopUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopUpdate>>,
          TError,
          Awaited<ReturnType<typeof shopUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopUpdate<TData = Awaited<ReturnType<typeof shopUpdate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    updateShopInputBody: NonReadonly<UpdateShopInputBody>,
    headers: ShopUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopUpdate>>,
          TError,
          Awaited<ReturnType<typeof shopUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopUpdate<TData = Awaited<ReturnType<typeof shopUpdate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    updateShopInputBody: NonReadonly<UpdateShopInputBody>,
    headers: ShopUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Настройки магазина
 */

export function useShopUpdate<TData = Awaited<ReturnType<typeof shopUpdate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    updateShopInputBody: NonReadonly<UpdateShopInputBody>,
    headers: ShopUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopUpdateQueryOptions(id,kind,updateShopInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDeliveryListResponse200 = {
  data: DeliveryMethodsOutputBody
  status: 200
}

export type shopDeliveryListResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDeliveryListResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDeliveryListResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDeliveryListResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDeliveryListResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDeliveryListResponseSuccess = (shopDeliveryListResponse200) & {
  headers: Headers;
};
export type shopDeliveryListResponseError = (shopDeliveryListResponse401 | shopDeliveryListResponse403 | shopDeliveryListResponse404 | shopDeliveryListResponse422 | shopDeliveryListResponse500) & {
  headers: Headers;
};

export type shopDeliveryListResponse = (shopDeliveryListResponseSuccess | shopDeliveryListResponseError)

export const getShopDeliveryListUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/delivery`
}

/**
 * @summary Способы доставки
 */
export const shopDeliveryList = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<shopDeliveryListResponse> => {

  return facetaFetch<shopDeliveryListResponse>(getShopDeliveryListUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopDeliveryListQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/shop/delivery`
    ] as const;
    }


export const getShopDeliveryListQueryOptions = <TData = Awaited<ReturnType<typeof shopDeliveryList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDeliveryListQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDeliveryList>>> = ({ signal }) => shopDeliveryList(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDeliveryListQueryResult = NonNullable<Awaited<ReturnType<typeof shopDeliveryList>>>
export type ShopDeliveryListQueryError = ErrorModel


export function useShopDeliveryList<TData = Awaited<ReturnType<typeof shopDeliveryList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryList>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryList<TData = Awaited<ReturnType<typeof shopDeliveryList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryList>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryList<TData = Awaited<ReturnType<typeof shopDeliveryList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Способы доставки
 */

export function useShopDeliveryList<TData = Awaited<ReturnType<typeof shopDeliveryList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDeliveryListQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDeliveryCreateResponse201 = {
  data: DeliveryMethodBody
  status: 201
}

export type shopDeliveryCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDeliveryCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDeliveryCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDeliveryCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDeliveryCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDeliveryCreateResponseSuccess = (shopDeliveryCreateResponse201) & {
  headers: Headers;
};
export type shopDeliveryCreateResponseError = (shopDeliveryCreateResponse401 | shopDeliveryCreateResponse403 | shopDeliveryCreateResponse404 | shopDeliveryCreateResponse422 | shopDeliveryCreateResponse500) & {
  headers: Headers;
};

export type shopDeliveryCreateResponse = (shopDeliveryCreateResponseSuccess | shopDeliveryCreateResponseError)

export const getShopDeliveryCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/delivery`
}

/**
 * В конец списка. Разные цены по городам — разные способы.
 * @summary Завести способ доставки
 */
export const shopDeliveryCreate = async (id: string,
    kind: 'production' | 'development',
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopDeliveryCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopDeliveryCreateResponse>(getShopDeliveryCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deliveryInputBody)
  }
);}





export const getShopDeliveryCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    deliveryInputBody?: NonReadonly<DeliveryInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/shop/delivery`, deliveryInputBody
    ] as const;
    }


export const getShopDeliveryCreateQueryOptions = <TData = Awaited<ReturnType<typeof shopDeliveryCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDeliveryCreateQueryKey(id,kind,deliveryInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDeliveryCreate>>> = ({ signal }) => shopDeliveryCreate(id,kind,deliveryInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDeliveryCreateQueryResult = NonNullable<Awaited<ReturnType<typeof shopDeliveryCreate>>>
export type ShopDeliveryCreateQueryError = ErrorModel


export function useShopDeliveryCreate<TData = Awaited<ReturnType<typeof shopDeliveryCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryCreate>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryCreate<TData = Awaited<ReturnType<typeof shopDeliveryCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryCreate>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryCreate<TData = Awaited<ReturnType<typeof shopDeliveryCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести способ доставки
 */

export function useShopDeliveryCreate<TData = Awaited<ReturnType<typeof shopDeliveryCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    deliveryInputBody: NonReadonly<DeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDeliveryCreateQueryOptions(id,kind,deliveryInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopDeliveryReorderResponse204 = {
  data: void
  status: 204
}

export type shopDeliveryReorderResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopDeliveryReorderResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopDeliveryReorderResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopDeliveryReorderResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopDeliveryReorderResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopDeliveryReorderResponseSuccess = (shopDeliveryReorderResponse204) & {
  headers: Headers;
};
export type shopDeliveryReorderResponseError = (shopDeliveryReorderResponse401 | shopDeliveryReorderResponse403 | shopDeliveryReorderResponse404 | shopDeliveryReorderResponse422 | shopDeliveryReorderResponse500) & {
  headers: Headers;
};

export type shopDeliveryReorderResponse = (shopDeliveryReorderResponseSuccess | shopDeliveryReorderResponseError)

export const getShopDeliveryReorderUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/delivery/order`
}

/**
 * В этом порядке их видит покупатель.
 * @summary Порядок способов доставки
 */
export const shopDeliveryReorder = async (id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody: NonReadonly<ReorderDeliveryInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopDeliveryReorderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopDeliveryReorderResponse>(getShopDeliveryReorderUrl(id,kind),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderDeliveryInputBody)
  }
);}





export const getShopDeliveryReorderQueryKey = (id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody?: NonReadonly<ReorderDeliveryInputBody>,) => {
    return [
    'PUT', `/sites/${id}/environments/${kind}/shop/delivery/order`, reorderDeliveryInputBody
    ] as const;
    }


export const getShopDeliveryReorderQueryOptions = <TData = Awaited<ReturnType<typeof shopDeliveryReorder>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody: NonReadonly<ReorderDeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopDeliveryReorderQueryKey(id,kind,reorderDeliveryInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopDeliveryReorder>>> = ({ signal }) => shopDeliveryReorder(id,kind,reorderDeliveryInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryReorder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopDeliveryReorderQueryResult = NonNullable<Awaited<ReturnType<typeof shopDeliveryReorder>>>
export type ShopDeliveryReorderQueryError = ErrorModel


export function useShopDeliveryReorder<TData = Awaited<ReturnType<typeof shopDeliveryReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody: NonReadonly<ReorderDeliveryInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryReorder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryReorder>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryReorder<TData = Awaited<ReturnType<typeof shopDeliveryReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody: NonReadonly<ReorderDeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryReorder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopDeliveryReorder>>,
          TError,
          Awaited<ReturnType<typeof shopDeliveryReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopDeliveryReorder<TData = Awaited<ReturnType<typeof shopDeliveryReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody: NonReadonly<ReorderDeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Порядок способов доставки
 */

export function useShopDeliveryReorder<TData = Awaited<ReturnType<typeof shopDeliveryReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderDeliveryInputBody: NonReadonly<ReorderDeliveryInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopDeliveryReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopDeliveryReorderQueryOptions(id,kind,reorderDeliveryInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopGiftCardsResponse200 = {
  data: GiftCardsOutputBody
  status: 200
}

export type shopGiftCardsResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopGiftCardsResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopGiftCardsResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopGiftCardsResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopGiftCardsResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopGiftCardsResponseSuccess = (shopGiftCardsResponse200) & {
  headers: Headers;
};
export type shopGiftCardsResponseError = (shopGiftCardsResponse401 | shopGiftCardsResponse403 | shopGiftCardsResponse404 | shopGiftCardsResponse422 | shopGiftCardsResponse500) & {
  headers: Headers;
};

export type shopGiftCardsResponse = (shopGiftCardsResponseSuccess | shopGiftCardsResponseError)

export const getShopGiftCardsUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/gift-cards`
}

/**
 * @summary Подарочные сертификаты
 */
export const shopGiftCards = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<shopGiftCardsResponse> => {

  return facetaFetch<shopGiftCardsResponse>(getShopGiftCardsUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopGiftCardsQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/shop/gift-cards`
    ] as const;
    }


export const getShopGiftCardsQueryOptions = <TData = Awaited<ReturnType<typeof shopGiftCards>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCards>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopGiftCardsQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopGiftCards>>> = ({ signal }) => shopGiftCards(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopGiftCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopGiftCardsQueryResult = NonNullable<Awaited<ReturnType<typeof shopGiftCards>>>
export type ShopGiftCardsQueryError = ErrorModel


export function useShopGiftCards<TData = Awaited<ReturnType<typeof shopGiftCards>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGiftCards>>,
          TError,
          Awaited<ReturnType<typeof shopGiftCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGiftCards<TData = Awaited<ReturnType<typeof shopGiftCards>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGiftCards>>,
          TError,
          Awaited<ReturnType<typeof shopGiftCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGiftCards<TData = Awaited<ReturnType<typeof shopGiftCards>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCards>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Подарочные сертификаты
 */

export function useShopGiftCards<TData = Awaited<ReturnType<typeof shopGiftCards>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCards>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopGiftCardsQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopGiftCardIssueResponse201 = {
  data: GiftCardBody
  status: 201
}

export type shopGiftCardIssueResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopGiftCardIssueResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopGiftCardIssueResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopGiftCardIssueResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopGiftCardIssueResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopGiftCardIssueResponseSuccess = (shopGiftCardIssueResponse201) & {
  headers: Headers;
};
export type shopGiftCardIssueResponseError = (shopGiftCardIssueResponse401 | shopGiftCardIssueResponse403 | shopGiftCardIssueResponse404 | shopGiftCardIssueResponse422 | shopGiftCardIssueResponse500) & {
  headers: Headers;
};

export type shopGiftCardIssueResponse = (shopGiftCardIssueResponseSuccess | shopGiftCardIssueResponseError)

export const getShopGiftCardIssueUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/gift-cards`
}

/**
 * Вручную — например, бумажный из розницы. Срок — из настроек магазина.
 * @summary Выпустить сертификат
 */
export const shopGiftCardIssue = async (id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody: NonReadonly<IssueGiftCardInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopGiftCardIssueResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopGiftCardIssueResponse>(getShopGiftCardIssueUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(issueGiftCardInputBody)
  }
);}





export const getShopGiftCardIssueQueryKey = (id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody?: NonReadonly<IssueGiftCardInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/shop/gift-cards`, issueGiftCardInputBody
    ] as const;
    }


export const getShopGiftCardIssueQueryOptions = <TData = Awaited<ReturnType<typeof shopGiftCardIssue>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody: NonReadonly<IssueGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardIssue>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopGiftCardIssueQueryKey(id,kind,issueGiftCardInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopGiftCardIssue>>> = ({ signal }) => shopGiftCardIssue(id,kind,issueGiftCardInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardIssue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopGiftCardIssueQueryResult = NonNullable<Awaited<ReturnType<typeof shopGiftCardIssue>>>
export type ShopGiftCardIssueQueryError = ErrorModel


export function useShopGiftCardIssue<TData = Awaited<ReturnType<typeof shopGiftCardIssue>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody: NonReadonly<IssueGiftCardInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardIssue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGiftCardIssue>>,
          TError,
          Awaited<ReturnType<typeof shopGiftCardIssue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGiftCardIssue<TData = Awaited<ReturnType<typeof shopGiftCardIssue>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody: NonReadonly<IssueGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardIssue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopGiftCardIssue>>,
          TError,
          Awaited<ReturnType<typeof shopGiftCardIssue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopGiftCardIssue<TData = Awaited<ReturnType<typeof shopGiftCardIssue>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody: NonReadonly<IssueGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardIssue>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Выпустить сертификат
 */

export function useShopGiftCardIssue<TData = Awaited<ReturnType<typeof shopGiftCardIssue>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    issueGiftCardInputBody: NonReadonly<IssueGiftCardInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopGiftCardIssue>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopGiftCardIssueQueryOptions(id,kind,issueGiftCardInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopPromosResponse200 = {
  data: PromosOutputBody
  status: 200
}

export type shopPromosResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopPromosResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopPromosResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopPromosResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopPromosResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopPromosResponseSuccess = (shopPromosResponse200) & {
  headers: Headers;
};
export type shopPromosResponseError = (shopPromosResponse401 | shopPromosResponse403 | shopPromosResponse404 | shopPromosResponse422 | shopPromosResponse500) & {
  headers: Headers;
};

export type shopPromosResponse = (shopPromosResponseSuccess | shopPromosResponseError)

export const getShopPromosUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/promos`
}

/**
 * @summary Промокоды магазина
 */
export const shopPromos = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<shopPromosResponse> => {

  return facetaFetch<shopPromosResponse>(getShopPromosUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getShopPromosQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/shop/promos`
    ] as const;
    }


export const getShopPromosQueryOptions = <TData = Awaited<ReturnType<typeof shopPromos>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromos>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopPromosQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopPromos>>> = ({ signal }) => shopPromos(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopPromos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopPromosQueryResult = NonNullable<Awaited<ReturnType<typeof shopPromos>>>
export type ShopPromosQueryError = ErrorModel


export function useShopPromos<TData = Awaited<ReturnType<typeof shopPromos>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromos>>,
          TError,
          Awaited<ReturnType<typeof shopPromos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromos<TData = Awaited<ReturnType<typeof shopPromos>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromos>>,
          TError,
          Awaited<ReturnType<typeof shopPromos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromos<TData = Awaited<ReturnType<typeof shopPromos>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromos>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Промокоды магазина
 */

export function useShopPromos<TData = Awaited<ReturnType<typeof shopPromos>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromos>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopPromosQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopPromoCreateResponse201 = {
  data: PromoBody
  status: 201
}

export type shopPromoCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopPromoCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopPromoCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopPromoCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type shopPromoCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopPromoCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopPromoCreateResponseSuccess = (shopPromoCreateResponse201) & {
  headers: Headers;
};
export type shopPromoCreateResponseError = (shopPromoCreateResponse401 | shopPromoCreateResponse403 | shopPromoCreateResponse404 | shopPromoCreateResponse409 | shopPromoCreateResponse422 | shopPromoCreateResponse500) & {
  headers: Headers;
};

export type shopPromoCreateResponse = (shopPromoCreateResponseSuccess | shopPromoCreateResponseError)

export const getShopPromoCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/promos`
}

/**
 * Код — без учёта регистра. Занят — 409.
 * @summary Завести промокод
 */
export const shopPromoCreate = async (id: string,
    kind: 'production' | 'development',
    promoInputBody: NonReadonly<PromoInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<shopPromoCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<shopPromoCreateResponse>(getShopPromoCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoInputBody)
  }
);}





export const getShopPromoCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    promoInputBody?: NonReadonly<PromoInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/shop/promos`, promoInputBody
    ] as const;
    }


export const getShopPromoCreateQueryOptions = <TData = Awaited<ReturnType<typeof shopPromoCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopPromoCreateQueryKey(id,kind,promoInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopPromoCreate>>> = ({ signal }) => shopPromoCreate(id,kind,promoInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopPromoCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopPromoCreateQueryResult = NonNullable<Awaited<ReturnType<typeof shopPromoCreate>>>
export type ShopPromoCreateQueryError = ErrorModel


export function useShopPromoCreate<TData = Awaited<ReturnType<typeof shopPromoCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    promoInputBody: NonReadonly<PromoInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromoCreate>>,
          TError,
          Awaited<ReturnType<typeof shopPromoCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromoCreate<TData = Awaited<ReturnType<typeof shopPromoCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopPromoCreate>>,
          TError,
          Awaited<ReturnType<typeof shopPromoCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopPromoCreate<TData = Awaited<ReturnType<typeof shopPromoCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести промокод
 */

export function useShopPromoCreate<TData = Awaited<ReturnType<typeof shopPromoCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    promoInputBody: NonReadonly<PromoInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopPromoCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopPromoCreateQueryOptions(id,kind,promoInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type shopReviewsCreateResponse201 = {
  data: ShopSettingsBody
  status: 201
}

export type shopReviewsCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type shopReviewsCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type shopReviewsCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type shopReviewsCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type shopReviewsCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type shopReviewsCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type shopReviewsCreateResponseSuccess = (shopReviewsCreateResponse201) & {
  headers: Headers;
};
export type shopReviewsCreateResponseError = (shopReviewsCreateResponse401 | shopReviewsCreateResponse403 | shopReviewsCreateResponse404 | shopReviewsCreateResponse409 | shopReviewsCreateResponse422 | shopReviewsCreateResponse500) & {
  headers: Headers;
};

export type shopReviewsCreateResponse = (shopReviewsCreateResponseSuccess | shopReviewsCreateResponseError)

export const getShopReviewsCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/shop/reviews`
}

/**
 * Коллекция «Отзывы о товарах»: имя, оценка, текст, товар, скрытая заметка; модерация; оставлять — вошедшим, один отзыв на товар от посетителя. Рейтинг товаров — из одобренных и опубликованных.
 * @summary Завести отзывы о товарах
 */
export const shopReviewsCreate = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<shopReviewsCreateResponse> => {

  return facetaFetch<shopReviewsCreateResponse>(getShopReviewsCreateUrl(id,kind),
  {
    ...options,
    method: 'POST'


  }
);}





export const getShopReviewsCreateQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/shop/reviews`
    ] as const;
    }


export const getShopReviewsCreateQueryOptions = <TData = Awaited<ReturnType<typeof shopReviewsCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopReviewsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopReviewsCreateQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopReviewsCreate>>> = ({ signal }) => shopReviewsCreate(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopReviewsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopReviewsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof shopReviewsCreate>>>
export type ShopReviewsCreateQueryError = ErrorModel


export function useShopReviewsCreate<TData = Awaited<ReturnType<typeof shopReviewsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopReviewsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopReviewsCreate>>,
          TError,
          Awaited<ReturnType<typeof shopReviewsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopReviewsCreate<TData = Awaited<ReturnType<typeof shopReviewsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopReviewsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopReviewsCreate>>,
          TError,
          Awaited<ReturnType<typeof shopReviewsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopReviewsCreate<TData = Awaited<ReturnType<typeof shopReviewsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopReviewsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести отзывы о товарах
 */

export function useShopReviewsCreate<TData = Awaited<ReturnType<typeof shopReviewsCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopReviewsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopReviewsCreateQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






